import { render, staticRenderFns } from "./imageEditor.vue?vue&type=template&id=45d877b0&"
import script from "./imageEditor.vue?vue&type=script&lang=js&"
export * from "./imageEditor.vue?vue&type=script&lang=js&"
import style0 from "./imageEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports